import { translationsDashboard_da_part1 } from "./translationsDashboard.da.part1";
import { defineTranslationTree } from "./translationTypes";
import { translationsDashboard_da_part2 } from "./translationsDashboard.da.part2";

export const translationsDashboard_da = defineTranslationTree({
  ...translationsDashboard_da_part1,
  ...translationsDashboard_da_part2,
});
